import { Icon } from 'components/Icon';
import { Image } from 'components/Image';
import { Money } from 'components/Money';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import { useModal } from 'components/modal/ModalStack';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { MAX_OPTION_QUANTITY, getOptionQuantity, getOptionTitle } from '../StoreProposedOptions';
import { thumbnailSource } from 'helpers/mediaSources';
import { saleItemHasViewerContent } from '../saleItemViewerContent';
import './ProposedOptionsPanel.scss';
import { Button } from 'components/Button';
import { StoreQuantityStepper } from './StoreQuantityStepper';
/**
 * @component ProposedOptionsPanel
 * @since 1.0.0
 */
export function ProposedOptionsPanel(props) {
    const { lang, options, productQuantity, selectedIds, optionQuantities, onChange, onQuantityChange } = props;
    const modal = useModal();
    const className = classNames('store-proposed-options-panel', props.className);
    /**
     * @function onOptionInfoClick
     * @since 1.0.0
     * @hidden
     */
    function onOptionInfoClick(event, option) {
        var _a, _b, _c;
        event.stopPropagation();
        if (!option.item) {
            return;
        }
        modal.present({
            title: (_c = (_b = (_a = option.item.translations) === null || _a === void 0 ? void 0 : _a.find((tr) => tr.language.code === lang)) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : option.item.sku,
            picto: '',
            className: 'deal-sale-item-selector-item-modal',
            modal: React.createElement(SaleItemViewer, { item: option.item, lang: lang, isStore: true })
        });
    }
    const includedOptions = options.filter((o) => { var _a; return o.included && ((_a = o.item) === null || _a === void 0 ? void 0 : _a.id); });
    const suggestedOptions = options.filter((o) => { var _a; return !o.included && ((_a = o.item) === null || _a === void 0 ? void 0 : _a.id); });
    function renderRow(option, isIncluded) {
        var _a, _b, _c, _d, _e;
        const optionItemId = option.item.id;
        const checked = !isIncluded && selectedIds.includes(optionItemId);
        const quantity = getOptionQuantity(option, productQuantity, optionQuantities);
        const optionTotal = option.price * quantity;
        const showInfo = saleItemHasViewerContent(option.item, lang, {
            textOnly: true
        });
        const showStepper = checked && option.quantityEditable && onQuantityChange != null;
        return (React.createElement("li", { key: option.id, className: classNames('store-proposed-options-panel__row', {
                'store-proposed-options-panel__row--checked': checked,
                'store-proposed-options-panel__row--included': isIncluded
            }) },
            React.createElement("div", { className: "store-proposed-options-panel__row-image" }, ((_b = (_a = option.item) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.image.url) ? (React.createElement(Image, { lazy: true, source: thumbnailSource(option.item.image.image) })) : (React.createElement("span", { className: "store-proposed-options-panel__row-initial" }, (_e = (_d = (_c = getOptionTitle(option, lang)) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.toUpperCase()) !== null && _e !== void 0 ? _e : '?'))),
            React.createElement("div", { className: "store-proposed-options-panel__row-main" },
                React.createElement("span", { className: "store-proposed-options-panel__name" }, getOptionTitle(option, lang)),
                isIncluded && quantity > 1 && (React.createElement("span", { className: "store-proposed-options-panel__quantity" },
                    "\u00D7",
                    quantity)),
                showInfo && (React.createElement("button", { type: "button", className: "store-proposed-options-panel__info", "aria-label": t('View details'), onClick: (event) => onOptionInfoClick(event, option) },
                    React.createElement(Icon, { value: "circle-info" })))),
            isIncluded ? (React.createElement("div", { className: "store-proposed-options-panel__meta" },
                React.createElement("span", { className: "store-proposed-options-panel__included-label" },
                    React.createElement(Icon, { value: "check" }),
                    t('Included')))) : (React.createElement("div", { className: "store-proposed-options-panel__meta" },
                option.recommended && (React.createElement("span", { className: "store-proposed-options-panel__badge" }, t('Popular'))),
                React.createElement("span", { className: "store-proposed-options-panel__price" },
                    "+\u00A0",
                    React.createElement(Money, { value: optionTotal })),
                showStepper ? (React.createElement(StoreQuantityStepper, { className: "store-proposed-options-panel__stepper", value: quantity, max: MAX_OPTION_QUANTITY, onChange: (next) => onQuantityChange === null || onQuantityChange === void 0 ? void 0 : onQuantityChange(optionItemId, next), onRemove: () => onChange(optionItemId, false) })) : (React.createElement(Button, { picto: checked ? 'times' : 'plus', label: checked ? t('Remove') : t('Add'), className: classNames('store-proposed-options-panel__add', {
                        'store-proposed-options-panel__add--checked': checked
                    }), selected: checked, onPress: () => onChange(optionItemId, !checked) }))))));
    }
    /**
     * @function renderGroup
     * @since 1.0.0
     * @hidden
     */
    function renderGroup(title, group, isIncluded) {
        if (group.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: classNames('store-proposed-options-panel__group', {
                'store-proposed-options-panel__group--included': isIncluded
            }) },
            React.createElement("h3", { className: classNames('store-proposed-options-panel__section-title', {
                    'store-proposed-options-panel__section-title--suggested': !isIncluded
                }) }, title),
            React.createElement("ul", { className: "store-proposed-options-panel__rows" }, group.map((o) => renderRow(o, isIncluded)))));
    }
    return (React.createElement("div", { className: className, onClick: (event) => event.stopPropagation() },
        renderGroup(t('Included options'), includedOptions, true),
        renderGroup(t('You may also like'), suggestedOptions, false)));
}
